import React, { Component } from 'react'
import { withCookies, Cookies } from 'react-cookie'

const isBrowser = typeof window !== 'undefined'

export default function withSafeCookies(WrappedComponent) {
  return class extends Component {
    static displayName = `withSafeCookies(${WrappedComponent.displayName || WrappedComponent.name})`
    
    constructor(props) {
      super(props)
      
      // Если это серверный рендеринг и есть пропс cookie, используем его
      if (!isBrowser && props.cookie) {
        this.cookies = {
          get: (name) => props.cookie[name],
          getAll: () => props.cookie,
          set: () => {},
          remove: () => {}
        }
      } else {
        // В браузере используем обычные куки
        this.cookies = isBrowser ? new Cookies() : { 
          get: () => null,
          getAll: () => ({}),
          set: () => {},
          remove: () => {}
        }
      }
    }

    render() {
      return <WrappedComponent {...this.props} cookies={this.cookies} />
    }
  }
}